<template>
	<div class="export-popi">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<h1>Export Product Return</h1>

		<p class="description">
			This page will export the product returns.
		</p>

		<div class="single-text-wrapper">
			<b-field label="Return Number (Optional)">
				<b-input v-model="returnNumber" placeholder="Return Number" @keyup.native.enter="exportReturn"></b-input>
			</b-field>
		</div>

		<div class="datepickerWrapper">
			<b-field label="Starting Date">
				<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</b-field>

			<b-field label="Ending Date">
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Click to select..."
					v-model="toDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</b-field>
		</div>

		<div class="button-container">
			<div class="big-button" @click="exportReturn()">
				Export Product Return
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'exportReturn',
	data: function() {
		return {
			limit: 20,
			fromDate: null,
			toDate: null,
			minDate: null,
			maxDate: null,
			returnNumber: null,
			isLoading: false
		}
	},

	watch: {
		fromDate: function(data) {
			if (data !== null) {
				this.minDate = data

				// Removed as client requested
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.toDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 1)
			} else {
				this.toDate = null
			}
		}
	},

	methods: {
		// Export products on user click
		exportReturn: async function() {
			// Make sure fromDate is not empty
			if (this.fromDate == null && (this.returnNumber == null || this.returnNumber == '')) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please enter Starting date'
				})

				return
			}

			this.isLoading = true

			const data = {
				limit: this.limit,
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.returnNumber !== null && this.returnNumber !== '') {
				data.code = this.returnNumber
			}

			if (this.fromDate) {
				data.time = {}
				data.time.updatedAt = {
					$gte: this.$moment(this.fromDate)
						.set({ hour: 0 })
						.format('x')
				}

				if (this.toDate) {
					data.time.updatedAt.$lte = this.$moment(this.toDate)
						.set({ hour: 23 })
						.format('x')
				}
			}

			let returns = []

			const result = await this.$api.getProductReturns({ data })

			if (result !== undefined && result.data.total > 0) {
				result.data.list.map(data => {
					returns.push(data)
				})

				// Loop more to get full results
				if (result.data.total > this.limit) {
					var totalLoop = Math.ceil(result.data.total / this.limit)

					var i
					var skip

					// Loop all the pagers
					for (i = 1; i < totalLoop; i++) {
						skip = i * this.limit

						data.skip = skip

						const result = await this.$api.getProductReturns({ data })

						if (result) {
							result.data.list.map(data => {
								returns.push(data)
							})
						}
					}
				}

				let returnProducts = []

				if (returns.length > 0) {
					for (let result in returns) {
						let id = returns[result]._id

						let data = {
							id,
							populate_return_product: ['author', 'shop', 'brand', 'supplier', 'warehouse'],
							populate_return_product_item: ['product']
						}

						const apiGetReturnDetail = await this.$api.getReturnDetail({ data })

						if (apiGetReturnDetail !== undefined) {
							returnProducts.push(apiGetReturnDetail.data)
						}
					}
				}

				this.generateCSV(returnProducts)
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}
		},

		generateCSV: function(returns) {
			let export_csv = ''

			// Loop data
			returns.map(data => {
				let return_product = data.return_product
				let return_product_items = data.return_product_items

				export_csv += 'RETURN CODE,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,LOCATION,SUPPLIER,REASON,DATE,RETURNED QUANTITY,REMARKS\r\n'

				// Map all the transfer products
				return_product_items.map(items => {
					// Determine branch name: prefer shop, fallback to warehouse, then 'N/A'
					let branchName = 'N/A'
					if (return_product.shop && return_product.shop.name) {
						branchName = return_product.shop.name
					} else if (return_product.warehouse && return_product.warehouse.name) {
						branchName = return_product.warehouse.name
					}

					const toAdd = [
						return_product.code,
						items.product.bd_code,
						items.product.barcode,
						'"' + items.product.name + '"',
						return_product.brand.name,
						return_product.brand.code,
						branchName,
						'"' + return_product.supplier.name + '"',
						return_product.type[0],
						this.$moment(return_product.createdAt).format('DD/MM/YY hh:mm a'),
						items.qty,
						return_product.description ? '"' + return_product.description + '"' : ''
					]

					let row = toAdd.join(',')

					export_csv += row + '\r\n'
				})

				export_csv += '\r\n'
			})

			this.isLoading = false

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Product_Return_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.returnNumber = null
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
